import {get} from "@/context/context";
import {CountryRepository} from "@/repositories/CountryRepository";
import {Country} from "@/models/Country";

export class CountryService {

    public countryRepository: CountryRepository = get('countryRepository');

    public async getCountries(): Promise<Country[]> {
        return await this.countryRepository.getCountries();
    }
}
